import { ADD_USERS_COURSE_PAGE_KEY } from '../constants';
import type { TAssignUserTranslationKeys } from './types';

const pt: TAssignUserTranslationKeys = {
  [ADD_USERS_COURSE_PAGE_KEY]: {
    TITLE_ADD_USER_COURSES: 'Atribuição de usuário',
    BACK_LABEL: 'Volver',
    TITLE_TABLE: 'Selecione os usuários que deseja atribuir ao seu curso:',
    COURSE_LABEL: 'Curso',
    LOADING_TITLE: 'Atribuindo usuários...',
    LOADING_DESCRIPTION: 'Terminaremos em breve, obrigado por esperar',
    ROLE_ALL: 'Tudo',
    ROLE_ADMIN: 'Administrador',
    ROLE_USER: 'Usuário',
    TITLE: 'Usuários',
    SEARCH: 'Pesquisar',
    SELECT_USER_ALL: 'Usuários selecionados no total',
    SELECT_USER: 'Usuários selecionados desta página',
    SELECT_USER_plural: 'Usuário selecionado nesta página',
    SELECT_USER_ALL_LABEL: 'Selecionar {{totalUser}} usuários',
    COLUMN_NAME: 'Nome',
    COLUMN_EMAIL: 'Contagem de erros',
    COLUMN_ROLE: 'Tipo',
    COLUMN_TAGS: 'Tags',
    COLUMN_STATUS: 'Status',
    SUCCES_ASSIGN: 'Usuário *{{count}}* atribuído com sucesso ao curso',
    SUCCES_ASSIGN_plural:
      '*{{count}}* usuários foram atribuídos com sucesso ao curso',
    SUCCES_SUBTITLE: 'Esses usuários agora poderão aproveitar o curso',
    SUCCESS_DESCRIPTION:
      'Agora você pode acessar os detalhes da sessão para obter mais informações',
    SUCCESS_DESCRIPTION_ASYNC:
      '**O processo pode demorar mais do que o esperado** Nós o notificaremos por correio após a conclusão',
    SUCCES_ASSIGN_ASYNC:
      'Os usuários estão sendo atribuídos à *{{count}}* curso.',
    SUCCES_ASSIGN_ASYNC_SUBTITLE:
      'Não se preocupe! Enviaremos um e-mail informando quando os usuários tiverem sido atribuídos com sucesso ao curso',
    BTN_ACTION: 'Atribuir usuários',
    BTN_ACTION_MANUAL: 'Atribuir usuários manualmente',
    BTN_ACTION_SEGMENTATION: 'Atribuir usuários por segmentação',
    BTN_CANCEL: 'Cancelar',
    MODAL_SEGMENTATION_TITLE: 'Gestão de atributos',
    MODAL_SEGMENTATION_DESCRIPTION:
      'Os atributos selecionados determinam quais usuários poderão visualizar o conteúdo da categoria selecionada.',
    MODAL_CONFIRM_TITLE: 'Confirmar atribuição de usuários',
    MODAL_CONFIRM_DESCRIPTION:
      'Revise os usuários selecionados antes de continuar',
    MODAL_CONFIRM_MANUAL_USERS: 'Usuários selecionados manualmente',
    MODAL_CONFIRM_SEGMENT_USERS: 'Usuários do segmento',
    MODAL_CONFIRM_NO_USERS: 'Não há usuários neste grupo',
    MODAL_CONFIRM_USER_COUNT: '{{count}} usuário',
    MODAL_CONFIRM_USER_COUNT_plural: '{{count}} usuários',
    MODAL_CONFIRM_NO_NAME: 'Sem nome',
    MODAL_CONFIRM_NO_EMAIL: 'Sem e-mail',
    MODAL_SAVE_BTN: 'Salvar',
    MODAL_CANCEL_BTN: 'Cancelar',
    ERROR_TITLE: 'Ocorreu um erro inesperado',
    ERROR_SUBTITLE: 'Por favor, tente novamente',
    ERROR_BTN: 'Eu entendo',
    BTN_LABEL: 'Entendido',
    SELECT_CATEGORY: 'Selecione uma categoria',
    SELECT_EMPTY: 'Nenhum resultado encontrado',
    SELECT_EMPTY_SUBTITLE: 'Tente palavras-chave mais gerais',
    STATUS_ACTIVE: 'Ativo',
    STATUS_PENDING: 'Pendente',
    TAB_TITLE: 'Como você deseja adicionar usuários ao seu curso?',
    TAB_SUBTITLE: 'Escolha sua opção preferida para atribuir usuários',
    TAB_MANUAL: 'Manualmente',
    TAB_MASSIVE: 'Massivamente',

    MASSIVE_FIRST_STEP: 'Use a planilha do Excel.',
    MASSIVE_FIRST_STEP_DOWNLOAD_TEMPLATE: 'Baixar planilha',
    MASSIVE_SECOND_STEP: 'Insira o e-mail de seus usuários.',
    MASSIVE_THIRD_STEP: 'Carregue o arquivo do Excel e \nclique em "Avançar".',
    STEP_2_TITLE: 'Validar dados',
    STEP_2_ERROR_TITLE: 'Erro de validação de dados',
    STEP_2_VALIDATION_ERROR: 'Ver detalhes do erro',
    STEP_2_POPPER_ERROR_2_TITLE: 'Registros não encontrados',
    STEP_2_POPPER_ERROR_2_SUBTITLE:
      'Verifique se o modelo que deseja enviar não está vazio, cada registro deve conter as informações do email.',
    STEP_2_POPPER_ERROR_2_BUTTON: 'Recarregue o arquivo',
    STEP_2_TABLE_TITLE: 'Validando dados do usuário...',
    STEP_2_VALIDATION_TITLE: 'Avaliando os requisitos:',
    STEP_2_VALIDATION_1: 'Validando cabeçalho do arquivo',
    STEP_2_VALIDATION_2:
      'Verificando a quantidade de usuários a serem alocados',
    STEP_2_VALIDATION_3: 'Verificando os e-mails',
    STEP_2_POPPER_ERROR_3_TITLE: 'Modelo incorreto',
    STEP_2_POPPER_ERROR_3_SUBTITLE:
      'Recomendamos que você baixe o modelo sugerido. Depois de preenchê-lo corretamente, você pode voltar e carregá-lo novamente.',
    STEP_2_POPPER_ERROR_3_BUTTON: 'Baixar modelo',
    STEP_2_POPPER_ERROR_1_TITLE: 'Um erro inesperado ocorreu',
    STEP_2_POPPER_ERROR_1_SUBTITLE:
      'Parece que houve um problema ao enviar seu arquivo. Tente novamente',
    STEP_2_POPPER_ERROR_1_BUTTON: 'Tente novamente',

    MASSIVE_STEP_UP: 'Carregar arquivo',
    MASSIVE_STEP_VALIDATION: 'Validar dados',
    MASSIVE_STEP_DETAIL: 'Detalhes de validação',
    MASSIVE_HEADER_DOWNLOAD: 'Baixar modelo',
    MASSIVE_HEADER_FILE: 'Digite o endereço de e-mail do seu usuário',
    MASSIVE_HEADER_NEXT:
      "Faça o upload do **arquivo Excel** e clique em 'Next'",
    MASSIVE_HEADER_DOWNLOAD_TITLE: 'Usar modelo do Excel',
    MASSIVE_ERROR_STEP_1: 'Formato inválido',
    MASSIVE_ERROR_STEP_1_REPLACE: 'Carregar outro arquivo',
    MASSIVE_ERROR_STEP_1_SUBTITLE:
      'Certifique-se de que o arquivo esteja em um formato válido, como .xlsx ou .csv. ',
    MASSIVE_STEP_1_TITLE: 'Selecione seu arquivo',
    MASSIVE_STEP_1_SUBTITLE:
      'Ou arraste e solte o arquivo .xlsx para carregá-lo',
    MASSIVE_STEP_1_SIZE: 'Peso máximo de 500kb',
    MASSIVE_STEP_1_IMPORTATION: 'Importações anteriores',
    MASSIVE_STEP_2_TITLE: 'Validação de dados',
    MASSIVE_STEP_2_SUBTITLE: 'Validando os dados do usuário...',
    MASSIVE_STEP_2_EVALUATION: 'Avaliando os requisitos',
    STEP_NEXT: 'Próximo',
    STEP_FINISHED: 'Adicionar usuários',
    MASSIVE_STEP_3_SUCCESS: 'E-mails validados com êxito',
    MASSIVE_STEP_3_SUCCESS_NOTE:
      'Detectamos e-mails duplicados, que serão mesclados para garantir que sejam considerados apenas uma vez no curso',
    MASSIVE_STEP_3_WARNING: 'E-mails registrados anteriormente no curso',
    MASSIVE_STEP_3_WARNING_NOTE:
      'Identificamos e-mails que já estão registrados neste curso. Esses e-mails não serão atribuídos novamente',
    MASSIVE_STEP_3_ERROR: 'E-mails com erros',
    MASSIVE_STEP_3_ERROR_NOTE:
      'Ao continuar com a validação, esses usuários não serão adicionados ao curso',
    MASSIVE_STEP_3_ERROR_NO_EMAIL: 'E-mails não registrados em sua organização',
    MASSIVE_STEP_3_ERROR_FORMAT_EMAIL: 'E-mails formatados de forma inválida',
    MASSIVE_STEP_3_ERROR_DISABLED_EMAIL:
      'E-mails de usuários excluídos ou inativos',
    MASSIVE_STEP_3_ERROR_DOWNLOAD: 'Erros de download',
    MASSIVE_STEP_2_DETAIL:
      'Baixe os detalhes do erro para que você possa corrigi-los e carregar o arquivo novamente. Ou, se desejar, você pode continuar com o upload apenas dos usuários validados com êxito',
    MASSIVE_FINISHED_TITLE:
      '*{{count}}* usuários estão sendo adicionados ao curso',
    MASSIVE_FINISHED_DESCRIPTION:
      'Esse processo pode demorar um pouco mais do que o esperado. Você será notificado assim que o processo for concluído.  ',
    ERROR_PERCENTAGE: 'Ocorreu um erro',
    COLUMN_REGISTER: 'NO RECORDS',
    COLUMN_USER: 'Usuário',
    COLUMN_UPLOAD_DATE: 'Data de importação',
    COLUMN_DETAIL_ERROR: 'Detalhe do erro',
    ERROR:
      'Por favor, tente carregar o arquivo novamente. Se o problema persistir, você pode tentar novamente mais tarde',
    ERROR_SIZE_TITLE: 'Peso do arquivo excedido',
    ERROR_SIZE:
      'O arquivo que você tentou adicionar excede o peso máximo permitido de {{size}} MB.',
    FILE_REEMPLACE_CUSTOM: 'Escolha outro arquivo',
    FILE_UPLOAD_CUSTOM: 'Fazer upload de arquivo',
    FILE_DURATION_CUSTOM: '0 minutos',
    FILE_TIME: '{{progresso}}% - {{duration}} para terminar',
    SWITCH_NOTIFICATION_NEW: 'Novo',
    SWITCH_NOTIFICATION_TITLE: 'Enviar e-mail para os colaboradores',
    SWITCH_NOTIFICATION_MESSAGE:
      ' Serve para notificar seus designados sobre a nova rota deles. Se você solicitou não receber e-mails, eles não serão enviados mesmo que a opção esteja ativada',
    SWITCH_NOTIFICATION_DIALOG_TITLE_plural:
      '*{{count}}* e-mails serão enviados',
    SWITCH_NOTIFICATION_DIALOG_TITLE: '*{{count}}* e-mail será enviado',
    SWITCH_NOTIFICATION_DIALOG_1:
      'Você ativou a opção de **enviar um e-mail notificando os colaboradores selecionados** da atribuição de rota.',
    SWITCH_NOTIFICATION_DIALOG_2:
      'Se preferir não enviar os e-mails, desative essa opção na parte superior da tabela de usuários',

    SWITCH_NOTIFICATION_COURSES_MESSAGE:
      'Serve para notificar seus designados sobre o novo curso. Se você solicitou não receber e-mails, eles não serão enviados mesmo que a opção esteja ativada',
    SWITCH_NOTIFICATION_DIALOG_COURSES_1:
      'Você ativou a opção de **enviar um e-mail notificando os colaboradores selecionados** da atribuição de curso.',
    SUCCESS_DESCRIPTION_COURSE:
      'Agora você pode acessar os detalhes da curso para obter mais informações',
    FILTER_HINT: 'Filtrar por',
  },
};

export default pt;
